// extracted by mini-css-extract-plugin
export default {"search":"Search_search__3SlmB","input":"Search_input__nV+zO","button":"Search_button__2BKM7"};